import { render, staticRenderFns } from "./subjectdl.vue?vue&type=template&id=380c7a80&"
import script from "./subjectdl.vue?vue&type=script&lang=js&"
export * from "./subjectdl.vue?vue&type=script&lang=js&"
import style0 from "./subjectdl.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports